export default __webpack_public_path__ + "static/media/life_point.7c116ffe.png";